import { Controller } from "react-hook-form";
import React, { Fragment } from "react";
import Select from "react-select";
import { formatGroupLabel } from "root/ReactHookForm/ui/DropdownDataProviders";

export const CommonDropdown = ({
                                   items, control, initialValue, styles, components, onChange, name,
                                   rules, placeholder, isSearchable, isClearable, isMulti, readOnly, validate, menuPlacement, minMenuHeight
                               }) =>
{
    const isReadOnly = readOnly === undefined ? false : readOnly ;

    const getReadOnlyContent = (value, items) =>
    {
        if (value === null || value === undefined)
        {
            return null;
        }

        if (Array.isArray(value))
        {
            return value.reduce((acc, cur) =>
            {
                const entry = items.find(element => +element.value === +cur.value);

                if (entry === undefined)
                {
                    return acc === '' ? 'Unknown Relation ID ' + cur.value : acc + ', ' + 'Unknown Relation ID ' + cur.value;
                }
                else
                {
                    return acc === '' ? entry.label : acc + ', ' + entry.label;
                }
            }, '');
        }
        else
        {
            let label = value.label;

            if (value.label === undefined)
            {
                const targetItem = items.find(element => +element.value === +value.value);

                if (targetItem !== undefined)
                {
                    label = targetItem.label;
                }
                else
                {
                    label = "Unknown ID " + value.value;
                }
            }

            return label;
        }
    }

    const getLabel = ( value ) =>
    {
        if ( value === null )
        {
            return null ;
        }

        let label = value.label ;

        if ( value.label === undefined )
        {
            const targetItem = items.filter ( (item) =>
            {
                if ( +(item.value) === +(value.value))
                {
                    return item ;
                }
            });

            if ( targetItem.length > 0 )
            {
                label = targetItem[0].label ;
            }
            else
            {
                label = "Unknown ID " + value.value ;
            }
        }

        return label ;
    }

    const initValue = (value, data) =>
    {
        let v = value ;

        let found = v === null || v === undefined ? null : data.find((element) =>
        {
            return element.value === v.value
        });

        if (Array.isArray(value))
        {
            const entry = value.map((cur) =>
            {
                const entry = items.find(element => +element.value === cur.value);

                if (entry !== undefined)
                {
                    return {value: entry.value, label: entry.label}
                }
                else
                {
                    return {value: cur.value, label: 'Unknown Relation ID ' + cur.value}
                }
            })

            return entry;
        }
        else if (data === null || data === undefined || data.length === 0 || found === undefined)
        {
            return null;
        }
        else if (value === undefined || value === null || value.value === undefined || value.value === null)
        {
            return value ;
        }
        else if ( value.label !== undefined )
        {
            return value ;
        }
        else
        {
            v = { value: value.value, label: getLabel ( value ) }
        }

        return v ;
    }

    if ( control === undefined )
    {
        return (
            <Fragment>
                { readOnly !== true && <Select
                    placeholder={ placeholder }
                    onChange={ onChange }
                    defaultValue={ initValue(initialValue) }
                    options={ items }
                    isSearchable={ isSearchable }
                    isClearable={ isClearable }
                    components={components}
                    isMulti={ isMulti }
                    styles={styles}
                    formatGroupLabel={ formatGroupLabel }/> }
                { isReadOnly === true && <input className='form-control' readOnly={ readOnly } defaultValue={ getLabel(value) }/> }
            </Fragment>
        )
    }
    else return (
        <Controller
            control={ control }
            name={ name }
            rules={ rules }
            validate={ validate }
            render={ ( {
                           field: { onChange, value, name, ref },
                           fieldState: { invalid, isTouched, isDirty, error },
                           formState
                       } ) => (
                <Fragment>
                        {<Select
                            //styles={customStyles}
                            className={'react-select-neil'}
                            placeholder={ placeholder }
                            onChange={ onChange }
                            defaultValue={initValue(value, items)}
                            options={ items }
                            ref={ref}
                            isDisabled={readOnly}
                            value={initValue(value, items)}
                            isSearchable={ isSearchable }
                            isClearable={ isClearable }
                            isMulti={ isMulti }
                            formatGroupLabel={ formatGroupLabel }
                            menuPlacement={ menuPlacement }
                            minMenuHeight={ minMenuHeight }
                        /> }
                </Fragment>
            ) }/>
    )
}